/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryRequest {
    getFixupPrototypeFunction() { return InventorySummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryRequest>): InventorySummaryRequest {
        let obj = Object.assign(new InventorySummaryRequest(), model);
        InventorySummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryRequest>): InventorySummaryRequest {
        if (!model) return null;
        return InventorySummaryRequest.newInstance(<InventorySummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryRequest) {
        if (!obj) return;

        models.InventorySummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryRequest): boolean {
        Object.setPrototypeOf(obj, InventorySummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.InventoryQueryFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Narrowing applied before the resources are counted. The same filter the list endpoint takes, so the selector counts what the grid lists. Omitted counts every resource the caller can reach.
     */
    filters: models.InventoryQueryFilter;

}
